export default {
    params: ['naoPossuiCpf'],
    computesRequired: true,
    validate: (value, { naoPossuiCpf }) => {

        const required = !naoPossuiCpf
        const valid = !required || !!String(value || '').trim()

        return { valid, required }
    },
    message: "Informe o CPF ou marque 'Não possui CPF' e selecione a justificativa.",
}
